import { TableColumn } from '@ui/aos-lib';
import { MeterTable } from 'src/app/services/data/devices-data/devices-data.types';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import {
  commodityTableIcon,
  deviceTypeTableIcon
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import {
  batteryStatusTooltip,
  deviceHealthTooltip,
  lastHeardTooltip,
  transmissionReadRateTooltip,
  validReadRateTooltip
} from 'src/app/shared/components/listing-table/listing-page.consts';
import { BubbleColumnComponent } from 'src/app/shared/components/listing-table/components/bubble-column.component';
import { IconColumnComponent } from 'src/app/shared/components/listing-table/components/icon-column.component';
import { StatusDotColumnComponent } from 'src/app/shared/components/listing-table/components/status-dot-column.component';
import { LocationColumnComponent } from 'src/app/shared/components/table-columns/location-column.component';
import { MultiLineColumnComponent } from 'src/app/shared/components/multi-line-column/multi-line-column.component';
import { AccountNumbersColumnComponent } from '../../components/column/account-numbers-column.component';
import { CommDeviceIdColumnComponent } from '../../components/column/comm-device-id-column.component';
import { SerialNumberColumnComponent } from '../../components/column/serial-number-column.component';

export const createMeteringColumns = (opts: { isSingleCommodityClient: boolean }): TableColumn[] => [
  {
    field: 'commDeviceId',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.COMM_DEVICE_ID,
    width: 200,
    sortable: false,
    cmp: CommDeviceIdColumnComponent
  },
  {
    field: 'serialNumber',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.SERIAL_NUMBER,
    width: 200,
    sortable: false,
    cmp: SerialNumberColumnComponent
  },
  {
    field: 'deviceTypeName',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.DEVICE_TYPE,
    width: 200,
    sortable: true,
    icon: deviceTypeTableIcon
  },
  {
    field: 'meterNumber',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.INVENTORY_ID,
    width: 200,
    sortable: true,
    text: (dataItem: MeterTable): string => `${dataItem.meterNumber ?? ''}`
  },
  {
    field: 'accountNumbers',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.ACCOUNT_NUMBER,
    width: 160,
    sortable: false,
    link: { getLink: (): string => 'link' },
    cmp: AccountNumbersColumnComponent
  },
  {
    field: 'serviceLocationIds',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.SERVICE_LOCATION_NUMBER,
    width: 120,
    sortable: false,
    cmp: MultiLineColumnComponent
  },
  {
    field: 'serviceLocationAddress',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.SERVICE_LOCATION_ADDRESS,
    width: 200,
    sortable: false,
    cmp: MultiLineColumnComponent
  },
  {
    field: 'commodity',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.COMMODITY,
    width: 126,
    sortable: true,
    icon: commodityTableIcon,
    cmp: IconColumnComponent,
    isHidden: opts.isSingleCommodityClient
  },
  {
    field: 'portNumber',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.PORT,
    width: 200,
    sortable: false,
    text: (dataItem: MeterTable): string => `${dataItem.portNumber ?? ''}`
  },
  {
    field: 'model',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.MODEL,
    width: 400,
    sortable: true
  },
  {
    field: 'status',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.STATUS,
    width: 200,
    sortable: false,
    cmp: StatusDotColumnComponent
  },
  {
    field: 'deviceStatusValue',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.HEALTH,
    width: 200,
    sortable: true,
    cmp: BubbleColumnComponent,
    tooltip: deviceHealthTooltip
  },
  {
    field: 'lastHeard',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.LAST_HEARD,
    width: 200,
    sortable: true,
    tooltip: lastHeardTooltip,
    text: (dataItem: MeterTable): string => `${dataItem.lastHeard ?? ''}`
  },
  {
    field: 'batteryStatus',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.BATTERY_STATUS,
    width: 200,
    sortable: false,
    cmp: BubbleColumnComponent,
    tooltip: batteryStatusTooltip
  },
  {
    field: 'transmissionReadRateStatus',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.READ_RATE_STATUS,
    width: 200,
    sortable: false,
    cmp: BubbleColumnComponent,
    tooltip: transmissionReadRateTooltip
  },
  {
    field: 'validTransmissionReadRateStatus',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.VALID_READ_RATE_STATUS,
    width: 200,
    sortable: false,
    cmp: BubbleColumnComponent,
    tooltip: validReadRateTooltip
  },
  {
    field: 'location',
    title: TranslateRegistry.get.METERING.VIEW_TABLE.LOCATION,
    width: 200,
    sortable: false,
    cmp: LocationColumnComponent
  }
];
